/**
 * How a proposal prints money and dates — shared by the PDF, the wizard and
 * the public page so the three never disagree about a number.
 */

/** Whole dollars with thousands separators: $12,450. */
export const money = (amount) =>
  `$${Math.round(amount).toLocaleString('en-US')}`;

/** "September 12, 2026". */
export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

/**
 * A proposal row's "Sent with the estimate to dana@… on September 27, 2026",
 * or null if it never went out. A proposal goes to the customer only with
 * an estimate send (the PDF attached, `send_estimate`'s `proposal_token`).
 */
export const sentLine = (sent) =>
  sent?.sentAt && sent?.sentTo
    ? `Sent with the estimate to ${sent.sentTo} on ${formatDate(sent.sentAt)}`
    : null;
